import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["value", "dragging", "index", "disabled"],
    _excluded2 = ["prefixCls", "overlay", "placement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
* This source code is quoted from rc-slider.
* homepage: https://github.com/react-component/slider
*/
import React from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import Tooltip from '../../wui-tooltip/src'; //import Tooltip from '../../wui-tooltip/src2';
//import Tooltip from 'bee-tooltip';

import Handle from './Handle';
export default function createSliderWithTooltip(Component) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_React$Component) {
    _inherits(ComponentWrapper, _React$Component);

    var _super = _createSuper(ComponentWrapper);

    function ComponentWrapper(props) {
      var _this;

      _classCallCheck(this, ComponentWrapper);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "handleTooltipVisibleChange", function (index, visible) {
        _this.setState(function (prevState) {
          return {
            visibles: _objectSpread(_objectSpread({}, prevState.visibles), {}, _defineProperty({}, index, visible)),
            index: index
          };
        });
      });

      _defineProperty(_assertThisInitialized(_this), "handleWithTooltip", function (_ref) {
        var _extends2;

        var value = _ref.value,
            dragging = _ref.dragging,
            index = _ref.index,
            disabled = _ref.disabled,
            restProps = _objectWithoutProperties(_ref, _excluded);

        var _this$props = _this.props,
            tipFormatter = _this$props.tipFormatter,
            tipProps = _this$props.tipProps,
            handleStyle = _this$props.handleStyle,
            getTooltipPopupContainer = _this$props.getTooltipPopupContainer,
            tooltipPlacement = _this$props.tooltipPlacement,
            _this$props$tooltipVi = _this$props.tooltipVisible,
            tooltipVisible = _this$props$tooltipVi === void 0 ? true : _this$props$tooltipVi;

        var _tipProps$prefixCls = tipProps.prefixCls,
            prefixCls = _tipProps$prefixCls === void 0 ? 'u-slider-tooltip' : _tipProps$prefixCls,
            _tipProps$overlay = tipProps.overlay,
            overlay = _tipProps$overlay === void 0 ? tipFormatter(value) : _tipProps$overlay,
            _tipProps$placement = tipProps.placement,
            placement = _tipProps$placement === void 0 ? 'top' : _tipProps$placement,
            restTooltipProps = _objectWithoutProperties(tipProps, _excluded2);

        _this.updateTooltipPosition();

        return /*#__PURE__*/React.createElement(Tooltip, _extends({}, restTooltipProps, (_extends2 = {
          className: prefixCls,
          overlay: overlay,
          shouldUpdatePosition: true,
          placement: placement,
          visible: !disabled && (_this.state.visibles[index] || dragging) && tooltipVisible,
          key: index,
          ref: function ref(_ref3) {
            return _this.tooltipRef[index] = _ref3;
          } //getPopupContainer={() => this.getDOMNode(index)}

        }, _defineProperty(_extends2, "placement", tooltipPlacement), _defineProperty(_extends2, "getPopupContainer", getTooltipPopupContainer || _this.getDefaultPosition), _extends2)), /*#__PURE__*/React.createElement(Handle, _extends({}, restProps, {
          style: _objectSpread({}, handleStyle[0]),
          ref: function ref(_ref2) {
            return _this.saveHandle(index, _ref2);
          },
          value: value,
          onMouseEnter: function onMouseEnter() {
            return _this.handleTooltipVisibleChange(index, true);
          },
          onMouseLeave: function onMouseLeave() {
            return _this.handleTooltipVisibleChange(index, false);
          }
        })));
      });

      _this.state = {
        visibles: {},
        index: 0
      };
      _this.handlesRefs = {};
      _this.tooltipRef = {};
      return _this;
    }

    _createClass(ComponentWrapper, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.updateTooltipPosition();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        this.updateTooltipPosition();
      }
    }, {
      key: "updateTooltipPosition",
      value: function updateTooltipPosition() {
        var index = this.state.index;

        if (this.tooltipRef[index]) {
          this.tooltipRef[index].forcePopupAlign && this.tooltipRef[index].forcePopupAlign();
        }
      }
    }, {
      key: "getDefaultPosition",
      value: function getDefaultPosition() {
        return document.body;
      }
    }, {
      key: "saveHandle",
      value: function saveHandle(index, handle) {
        this.handlesRefs[index] = handle;
      }
    }, {
      key: "getDOMNode",
      value: function getDOMNode(index) {
        return findDOMNode(this.handlesRefs[index]);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(Component, _extends({}, this.props, {
          handle: this.handleWithTooltip
        }));
      }
    }]);

    return ComponentWrapper;
  }(React.Component), _defineProperty(_class, "propTypes", {
    tipFormatter: PropTypes.func,
    handleStyle: PropTypes.arrayOf(PropTypes.object),
    tipProps: PropTypes.object
  }), _defineProperty(_class, "defaultProps", {
    tipFormatter: function tipFormatter(value) {
      return value;
    },
    handleStyle: [{}],
    tipProps: {}
  }), _temp;
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-slider/src/createSliderWithTooltip.js